import { useNavigate } from "react-router-dom";
import Button from "../../atoms/button";

export default function WithdrawCompleteScreen() {
  const navigate = useNavigate()

  return (
    <div className="flex flex-col justify-between min-h-screen px-[35px]">
      <div className="flex flex-col justify-center items-center text-center flex-1">
        <img className="w-[225px]" src="/images/img-login-logo.webp" />
        <p className="text-[32px] font-bold pt-[13px] pb-[24px]">
          그동안 이용해<br />주셔서 감사합니다.
        </p>
        <span className="text-[14px] text-[#888] font-[500]">
          사용하시면서 아쉬운 점이 있으셨군요.
          <br />
          더 좋은 서비스로 찾아뵙겠습니다.
        </span>
      </div>
      <div className="space-y-[10px] pb-[35px]">
        <Button
          onClick={() => {
            navigate("/login")
          }}
          className="w-full font-bold"
          variant={"black"}
          label="확인"
        />
      </div>
    </div>
  );
}
